<div
  style="position: relative"
  [style.width]="responsive && !width ? null : width"
  [style.height]="responsive && !height ? null : height">
  <canvas
    [class]="canvasClasses()"
    class="max-w-full"
    role="img"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledBy"
    [attr.width]="responsive && !width ? null : width"
    [attr.height]="responsive && !height ? null : height"
    (click)="onCanvasClick($event)"></canvas>
</div>
